import { render, staticRenderFns } from "./MessageEmbedModal.vue?vue&type=template&id=a2541372&scoped=true&"
import script from "./MessageEmbedModal.vue?vue&type=script&lang=js&"
export * from "./MessageEmbedModal.vue?vue&type=script&lang=js&"
import style0 from "./MessageEmbedModal.vue?vue&type=style&index=0&id=a2541372&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2541372",
  null
  
)

export default component.exports